import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import VSpace from "../../common/VSpace"
import { faCheck } from "@fortawesome/pro-solid-svg-icons"
import QuickBooksDisconnectButton from "./QuickBooksDisconnectButton"
import QuickBooksConnectButton from "./QuickBooksConnectButton"
import { useQuickBooksConnectionStatus } from "./quickBooksQueries"

const QuickBooksIntegrationPage = () => {
    const connectedStatusQuery = useQuickBooksConnectionStatus()
    const isConnected = connectedStatusQuery.data

    if(connectedStatusQuery.isLoading){
        return <></>
    }

    return <>
        <VSpace>
            <p style={{marginBottom: '20px'}}>Take SynkedUP to the next level by connecting with your QuickBooks Online account. Built to streamline invoicing, timesheets, and managing your customers.  <a href="https://help.synkedup.com/en/articles/8901545-synkedup-success-checklist-how-to-connect-to-your-quickbooks-online-account" target="_blank" rel="noreferrer" style={{color: 'blue'}}>Learn how</a></p>
        </VSpace>
        { isConnected ? 
            <div>
                <span style={{marginTop: '20px'}}>
                    <b>Status: </b> Connected <FontAwesomeIcon icon={faCheck} color="green" />
                    <span  style={{marginLeft: '40px'}}>
                        <QuickBooksDisconnectButton />
                    </span>
                </span>
            </div>
            :
            <QuickBooksConnectButton />
        }
    </>
}

export default QuickBooksIntegrationPage